import { PublicSellerCenterAccountApiClient } from '@/apis';

export default class ForgotPasswordService {
  resetPasswordByPhone (phone, options) {
    return PublicSellerCenterAccountApiClient.post('/reset-password-by-phone', { phone }, options);
  }

  validateResetPasswordByPhone (data, options) {
    return PublicSellerCenterAccountApiClient.post('/reset-password-by-phone/otp/validate', data, options);
  }
}
